var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSupport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#456595",
  fillRule: "evenodd",
  d: "M18 0H2C.9 0 .01.9.01 2L0 20l4-4h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm0 14H3.17l-.59.59-.58.58V2h16v12Z",
  clipRule: "evenodd"
})));
export { SvgSupport as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCAwSDJDMC45IDAgMC4wMSAwLjkgMC4wMSAyTDAgMjBMNCAxNkgxOEMxOS4xIDE2IDIwIDE1LjEgMjAgMTRWMkMyMCAwLjkgMTkuMSAwIDE4IDBaTTE4IDE0SDMuMTdMMi41OCAxNC41OUwyIDE1LjE3VjJIMThWMTRaIiBmaWxsPSIjNDU2NTk1Ii8+Cjwvc3ZnPgo=";